import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { LocationSummary } from "../../lib/types";

export const useLocations = () =>
	useQuery({
		queryKey: ["locations"],
		queryFn: () => api.get<{ items: LocationSummary[] }>("/api/locations"),
	});
